<template>
    <front-page-search></front-page-search>
</template>

<script>
import FrontPageSearch from "./components/FrontPageSearch";

export default {
        name: "App",
        components: {
            FrontPageSearch
        },
    }
</script>